<template>
  <div class="team-member-avatar">
    <DarwinAvatar
      :id="id"
      :name="fullName"
      :url="url"
      :has-tooltip="hasTooltip"
      :size="size"
    />

    <div
      v-if="showPartner && partner"
      class="team-member-avatar__partner"
    >
      <DarwinAvatar
        :id="partner.id"
        :name="partner.name"
        :url="partner.image?.thumbnail_url || partner.image?.url"
        :has-tooltip="false"
        :size="10"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMembershipStore } from '@/modules/Teams/useMembershipStore'
import { computed } from 'vue'
import DarwinAvatar from '@/uiKit/Avatar/DarwinAvatar.vue'
import { useTeamStore } from '@/pinia/useTeamStore'

const props = withDefaults(
  defineProps<{
    id?: number
    name?: string
    hasTooltip?: boolean
    showPartner?: boolean
    size?: number
  }>(),
  { id: undefined, name: undefined, hasTooltip: true, showPartner: true, size: 20 },
)

const membershipStore = useMembershipStore()
const teamStore = useTeamStore()

const fullName = computed(() => (props.id ? membershipStore.memberNameById[props.id] : props.name))

const url = computed(() => (props.id ? membershipStore.memberAvatarUrlById[props.id] : null))

const avatarSize = computed(() => `${props.size}px`)

const partner = computed(() =>
  teamStore.currentTeam?.managed_status === 'client' ? teamStore.currentTeam.partner : null,
)
</script>

<style lang="scss" scoped>
.team-member-avatar {
  position: relative;
  height: v-bind(avatarSize);
  width: v-bind(avatarSize);

  &__partner {
    position: absolute;
    display: block;
    bottom: 0px;
    right: 0px;
  }
}
</style>
